<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
        >添加</el-button
      >
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button 
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      > -->
      <el-button
        slot="reference"
        type="danger"
        size="mini"
        style="margin-left: 10px"
        @click="openDelete"
        >删除</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1411px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="orders" label="排序" width="100" />
      <el-table-column prop="withdrawSum" label="图片" width="100">
        <template slot-scope="scoped">
          <el-image
            style="width: 60px; height: 60px"
            :src="scoped.row.image"
            fit="fill"
            :preview-src-list="new Array(scoped.row.image)"
            @click.stop="handleClickItem"
          />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="币种" width="100" />
      <el-table-column prop="fullName" label="币种全称" width="100" />
      
      <el-table-column prop="minRechargeAmount" label="币种最小充值数量" width="100" />
      <el-table-column prop="exMin" label="币种兑USDT最低兑换多少数量" width="150" />
      <el-table-column prop="ratio1" label="是否支持波场网络充值" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.isTrc20" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isTrc20" style="color:red">否</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="trc20ContractAddress" label="波场合约地址" width="200" />
      <el-table-column prop="unit" label="波场金额单位" width="120" /> -->
      <el-table-column prop="subjectStr" label="是否支持币安网络充值" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.isBep20" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isBep20" style="color:red">否</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="bep20ContractAddress" label="币安合约地址" width="200" /> -->
      <el-table-column prop="subjectStr" label="是否支持以太坊网络充值" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.isEth" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isEth" style="color:red">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="subjectStr" label="是否支持POL网络充值" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.isPol" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isPol" style="color:red">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="170" />

    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="排序">
          <el-input v-model="active.orders" placeholder="请输入排序" />
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage ref="image1" @upLoadImage="upLoadImage1"></UploadImage>
        </el-form-item>
        <el-form-item label="币种">
          <el-input v-model="active.name" placeholder="请输入币种" />
        </el-form-item>
        <el-form-item label="币种全称">
          <el-input
            v-model="active.fullName"
            placeholder="请输入币种全称"
          />
        </el-form-item>
        
        <el-form-item label="币种最小充值金额">
          <el-input v-model="active.minRechargeAmount" placeholder="请输入币种最小充值金额" />
        </el-form-item>
        <el-form-item label="币种兑USDT最低兑换多少">
          <el-input v-model="active.exMin" placeholder="请输入币种兑USDT最低兑换多少" />
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="isTrc20">是否支持波场</el-checkbox>
          <el-checkbox v-model="isBep20">是否支持币安</el-checkbox>
          <el-checkbox v-model="isEth">是否支持以太坊</el-checkbox>
          <el-checkbox v-model="isPol">是否支持POL</el-checkbox>
        </el-form-item>
        <el-form-item label="波场合约地址">
          <el-input v-model="active.trc20ContractAddress" placeholder="请输入波场合约地址" /> 
        </el-form-item>
        <el-form-item label="币安合约地址">
          <el-input v-model="active.bep20ContractAddress" placeholder="请输入币安合约地址" /> 
        </el-form-item>
        <el-form-item label="以太坊合约地址">
          <el-input v-model="active.ethContractAddress" placeholder="请输入以太坊合约地址" /> 
        </el-form-item>
        <el-form-item label="POL合约地址">
          <el-input v-model="active.polContractAddress" placeholder="请输入POL合约地址" /> 
        </el-form-item>
        
        
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
            <el-button slot="reference" type="primary" class="edit-button"
              >添加</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      width="700px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="排序">
          <el-input v-model="editForm.orders" placeholder="请输入排序" />
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage ref="image2" @upLoadImage="upLoadImage2"></UploadImage>
        </el-form-item>
        <el-form-item label="币种">
          <el-input v-model="editForm.name" placeholder="请输入币种" />
        </el-form-item>
        <el-form-item label="币种全称">
          <el-input
            v-model="editForm.fullName"
            placeholder="请输入币种全称"
          />
        </el-form-item>
        
        <el-form-item label="币种最小充值金额">
          <el-input v-model="editForm.minRechargeAmount" placeholder="请输入币种最小充值金额" />
        </el-form-item>
        <el-form-item label="币种兑USDT最低兑换多少">
          <el-input v-model="editForm.exMin" placeholder="请输入币种兑USDT最低兑换多少" />
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="editForm.isTrc20">是否支持波场</el-checkbox>
          <el-checkbox v-model="editForm.isBep20">是否支持币安</el-checkbox>
          <el-checkbox v-model="editForm.isEth">是否支持以太坊</el-checkbox>
          <el-checkbox v-model="editForm.isPol">是否支持POL</el-checkbox>
        </el-form-item>
        <el-form-item label="波场合约地址">
          <el-input v-model="editForm.trc20ContractAddress" placeholder="请输入波场合约地址" /> 
        </el-form-item>
        <el-form-item label="币安合约地址">
          <el-input v-model="editForm.bep20ContractAddress" placeholder="请输入币安合约地址" /> 
        </el-form-item>
        <el-form-item label="以太坊合约地址">
          <el-input v-model="editForm.ethContractAddress" placeholder="请输入以太坊合约地址" /> 
        </el-form-item>
        <el-form-item label="POL合约地址">
          <el-input v-model="editForm.polContractAddress" placeholder="请输入POL合约地址" /> 
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="investUpdate()">
            <el-button slot="reference" type="primary" class="edit-button"
              >更新</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap, UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: {},
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], //
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      editDialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      num: 24,
      isCross: false,
      isRed: false,
      isBep20: false,
      isTrc20: false,
      isEth: false,
      isPol: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    upLoadImage1(img) {
      this.active.image = img;
    },
    upLoadImage2(img) {
      this.editForm.image = img;
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 编辑
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.image2.init(this.editForm.image);
      });
    },
    investUpdate() {
      this.$api.trade
        .update(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.editDialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.trade
        .list(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.trade
        .tradeTicketDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.isBep20 = false
      this.isTrc20 = false
      this.isEth = false
      this.isPol = false
      this.active = {}
      this.$nextTick(() => {
        this.$refs.image1.init('');
      });
    },
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d;
    },
    // 添加用户
    bannerSave() {
      this.active.isTrc20 = this.isTrc20
      this.active.isBep20 = this.isBep20
      this.active.isEth = this.isEth
      this.active.isPol = this.isPol
      this.$api.trade
        .save(this.active)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
